import CloseIcon from '@mui/icons-material/Close';
import { Button,Dialog,DialogActions,DialogContent,DialogTitle,IconButton,Skeleton } from '@mui/material';
import { useMutation,useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import AttToken from '../../../../helpers/attToken';
import { ConjuntoType } from '../../../../service/Places';
import queryClient from '../../../../service/query';
import ServiceTypes from '../../../../service/ServiceTypes';
import Set from '../../../../service/Set';
import GenericAutoComplete from '../../../GenericAutoComplete';

type props = {
  open: boolean,
  setOpen: Function,
  set: ConjuntoType,
};

const services = new ServiceTypes();
const SetService = new Set();

export default function SetTypeAssoci({ open, setOpen, set }: props) {
  const { t } = useTranslation('translation');
  const [selectedServices, setSelectedServices] = useState<string[]>(set.tiposServico || []);

  const { data, isLoading } = useQuery({
    queryKey: ['GET_SERVICES_FOR_PLACES'],
    queryFn: async () => {
      const promise = toast.promise(async () => {
        const token = await AttToken();
        if (token) {
          const response = await services.getAllByCompany({ ...token, empresa: token.userEmpresa });
          if (!response) throw new Error('Erro ao buscar');
          return response;
        }
      }, {
        error: 'Erro ao buscar',
      }, { toastId: 'buscando_servicos' });
      return promise;
    }
  });

  const { mutate, isPending } = useMutation({
    mutationKey: ['UPDATE_PLACES'],
    mutationFn: async () => {
      const promise = toast.promise(async () => {
        const token = await AttToken();
        if (token) {
          const res = await SetService.addServiceType({ ...token }, selectedServices, set.id);
          if (!res) throw new Error('erro ao salvar');
          return res;

        }
      }, {
        pending: t('places.salvando'),
        error: t('places.erroSalvar'),
        success: t('Services.ServiceModal.typesAddedSuccessfully')
      }, { toastId: 'salvandoEdit' });
      return promise;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['GET_PLACES'] });
      queryClient.resetQueries({ queryKey: ['GET_CLIENTES'] });
      setOpen(false);
    }
  });

  const onLoading = isLoading || isPending;

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={open}
      onClose={() => setOpen(false)}
      scroll={'paper'}
    >
      <DialogTitle>{t('places.Associar_Tipos_de_Serviço')}</DialogTitle>
      <IconButton
        onClick={() => setOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        {isLoading
          ? <Skeleton variant='rounded' height={50} />
          : <GenericAutoComplete
            selectedValues={selectedServices ?? []}
            label={t('Services.servicesManagement.kind').replace(':', '')}
            options={(data as { nome: string, tipoId: string }[])
              ?.sort((a, b) => { return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1; })
              ?.map((ele) => ({
                label: ele.nome,
                value: ele.tipoId,
              })) ?? []}
            onChange={(values) => setSelectedServices(values)}
          />}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={onLoading}
          onClick={() => mutate()}
        >
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
